import { PatientDocumentControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchiveDocument = () =>
  useMutationWithLoading(
    async (param: {
      patientDocumentId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new PatientDocumentControllerApi(
        getConfigObject()
      ).updatePatientDocumentArchiveStatus(
        param.patientDocumentId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
